// File: frontend/src/components/marketing/heroIntro.js
//
// The hero's first-load intro, shared by HeroSection (lazy chunk) and
// src/index.js (main bundle). Keep this module free of imports.
//
// On a direct visit the landing page is painted from static HTML before any
// JavaScript runs. The intro is therefore CSS: the head script written by
// scripts/prerender.js sets `data-intro` on <html> (motion allowed, static copy
// shown), and HeroSection's styles animate the hero under that attribute.
//
// React replaces the static markup instead of hydrating it, and a replaced
// element restarts its CSS animation. So index.js publishes how far the intro
// had got as `--pf-intro-elapsed` and the styles subtract it from each part's
// animation-delay: the new elements continue mid-sequence. `data-intro` comes
// off INTRO_MS after the head script ran — while it is there, HeroSection
// leaves the hero to CSS and does not play its GSAP intro as well.
//
// On client-side navigation to "/" there is no static paint, so HeroSection
// plays the same sequence with GSAP instead.

export const INTRO_MS = 1150;

// Delay (ms) of each hero part, in order of appearance. The CSS intro and the
// GSAP timeline both read these, so the two paths look the same. INTRO_MS must
// stay above the last delay plus its duration, or `data-intro` is removed
// mid-sequence and the remaining parts snap in.
//
// `scene` is the photographic background, and it is the LCP element: it starts
// at 0 so the largest paint is never waiting on the copy, and it only ever
// fades (see HeroSection for why a transform on it costs ~1.8s of LCP).
export const INTRO_DELAY = {
  scene: 0,
  title: 60,
  copy: 150,
  cta: 240,
  trust: 340,
  caption: 420,
};
